import { NotificationCategory } from '@/types'

import { createLocalStorageItem, LocalStorageItem, parseBoolean } from './localStorageItem'

const STORAGE_KEY_PREFIX = 'valk-talk-notification-category-in-app'

export const inAppEnabledStorage = (category: NotificationCategory, userId: string): LocalStorageItem<boolean> => createLocalStorageItem({
    key: `${STORAGE_KEY_PREFIX}:${category}:${userId}`,
    // Unset means "never touched" - defaults to 'enabled'.
    fallback: true,
    parse: parseBoolean,
})

export const getInAppEnabled = (category: NotificationCategory, userId: string): boolean => inAppEnabledStorage(category, userId).get()

export const setInAppEnabled = (category: NotificationCategory, userId: string, enabled: boolean): void => {
    inAppEnabledStorage(category, userId).set(enabled)
}
